/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropprizename2Inputs */

const en_dropprizename2 = /** @type {(inputs: Dropprizename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prize`)
};

const de_dropprizename2 = /** @type {(inputs: Dropprizename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewinn`)
};

/**
* | output |
* | --- |
* | "Prize" |
*
* @param {Dropprizename2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropprizename2 = /** @type {((inputs?: Dropprizename2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropprizename2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropprizename2(inputs)
	return de_dropprizename2(inputs)
});
export { dropprizename2 as "dropPrizeName" }